import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=f38afc30"
import script from "./navItem.vue?vue&type=script&lang=js"
export * from "./navItem.vue?vue&type=script&lang=js"
import style0 from "./navItem.vue?vue&type=style&index=0&id=f38afc30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports